// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import 'vue-select/dist/vue-select.css';
import smartTag from 'vue-atinternet-smarttag';

const Bugsnag = require('@bugsnag/js');
const BugsnagPluginVue = require('@bugsnag/plugin-vue');
Bugsnag.start({
  autoTrackSessions: true,
  apiKey: process.env.BUGSNAG_API_KEY,
  enabledReleaseStages: ['staging', 'production'],
  releaseStage: process.env.NODE_ENV,
  plugins: [
    new BugsnagPluginVue()
  ]
})
Bugsnag.getPlugin('vue').installVueErrorHandler(Vue)

import 'es6-promise/auto'
import "babel-polyfill";
import App from './App'
import { router } from './router'
import axios from './backend/vue-axios'
import store from './store'
import jQuery from 'jquery'
import classie from 'classie'
import moment from 'moment'

window.classie = classie
window.jQuery = window.$ = jQuery
window.Popper = require('popper.js')
window.Tether = require('tether')
window.semver = require('semver')
window.moment = moment
window.interact = require('./assets/js/interact.min.js')

require('jquery-ui')
require('bootstrap')
require('select2')
require('jquery.scrollbar')
require('switchery')
require('jquery-validation')
require('font-awesome-webpack')
require('moment')
require('./assets/js/bootstrap-plugins/bootstrap-datepicker.js')
require('./assets/js/bootstrap-plugins/bootstrap-datepicker.fr.js')
require('./assets/js/bootstrap-plugins/bootstrap-timepicker.min.js')
require('./at_internet/config.js')

import('./assets/js/pages.js')
import i18n from './lang'
import Multiselect from 'vue-multiselect'
import VuejsDialog from "vuejs-dialog"
import filters from './filters'
import mixin from './mixin'
import { abilitiesPlugin } from '@casl/vue'
import defineAbilitiesFor from './config/ability'
import VTooltip from 'v-tooltip'
import HighchartsVue from 'highcharts-vue'
import vSelect from 'vue-select'

require('./validators')

Vue.component('v-select', vSelect);
Vue.component('multiselect', Multiselect);
Vue.use(HighchartsVue);
Vue.use(smartTag);

import pdf from 'vue-pdf';
Vue.component('pdf', pdf);


Vue.use(VuejsDialog, {
  okText: i18n.t('buttons.yes'),
  cancelText: i18n.t('buttons.no'),
  reverse: true,
  html: true
})

let ability = defineAbilitiesFor({});
Vue.use(abilitiesPlugin, ability)
window.ability = ability // for testing purpose
Vue.use(VTooltip)

Vue.config.productionTip = false

/* eslint-disable no-new */

new Vue({
  el: '#app',
  i18n,
  store,
  router,
  axios,
  filters,
  mixin,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js